import api from './client';

export interface FraudProtectionSettings {
  enabled: boolean;
  min_order_amount_cents: number;
}

export interface FraudFlaggedOrder {
  id: number;
  shopify_order_id: number;
  order_number: string | null;
  total_price: number;
  reasons: string[];
  risk_recommendation: string | null;
  created_at: string | null;
}

export const fraudProtectionApi = {
  settings: () => api.get<{ data: FraudProtectionSettings }>('/fraud-protection'),

  updateSettings: (payload: FraudProtectionSettings) =>
    api.put<{ data: FraudProtectionSettings }>('/fraud-protection', payload),

  flaggedOrders: (page = 1) =>
    api.get<{ data: FraudFlaggedOrder[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/fraud-protection/flagged-orders?page=${page}`
    ),
};
